export const WEATHER_ENABLED = process.env.VUE_APP_ENABLE_WEATHER === 'true';
